"use client";

import Image from "next/image";

import charlotte from "@/assets/images/charlotte.png";
import Button from "@/components/atoms/Button";
import { DiamondForCharlotte } from "@/components/atoms/DiamondForCharlotte";
import Icon from "@/components/atoms/Icon";
import { useCharlotteChat } from "@/components/charlotte-chat/hooks/useCharlotteChat";
import { ChatbotSuggestionsParagraphFieldsFragment } from "@/graphql/sdk/__generated__";
import { cn } from "@/helpers/className";

interface Props {
  className?: string;
  data: ChatbotSuggestionsParagraphFieldsFragment;
}

export const ChatbotSuggestionsParagraph = ({ data, className }: Props) => {
  const { open } = useCharlotteChat();

  const handleOpenChat = () => {
    open();
  };

  return (
    <div className={cn("paragraph--chat container overflow-hidden", className)}>
      <div className="grid grid-cols-12">
        <div className="col-span-12 lg:col-span-10 lg:col-start-2 xl:col-span-8 xl:col-start-3 2xl:col-span-6 2xl:col-start-4">
          <div className="flex flex-row items-start gap-6">
            <div className="flex flex-col items-center gap-2 md:gap-2.5">
              <div className="relative">
                <Image
                  src={charlotte}
                  alt="Charlotte"
                  className="ratio-square w-[80px] flex-shrink-0 md:w-[159px]"
                  width="159"
                  height="159"
                />
                <DiamondForCharlotte className="absolute right-[-41px] top-[29px] md:top-[59px]" />
              </div>
              <span className="font-regular text-black-400 md:font-medium">
                Charlotte
              </span>
            </div>
            <div className="flex flex-grow flex-col gap-y-6 rounded-2xl bg-green p-6 md:p-12">
              {data.title && <h5 className="text-white">{data.title}</h5>}
              {data.chatBubbleText && (
                <div
                  className="text-white"
                  dangerouslySetInnerHTML={{
                    __html: data.chatBubbleText.processed ?? "",
                  }}
                />
              )}
              {data.btnLinks && (
                <div className="relative h-14">
                  <div className="no-scrollbar absolute -right-4 left-0 overflow-x-scroll lg:-right-10">
                    <div className="flex gap-2">
                      {data.btnLinks.map((link) => (
                        <Button
                          key={link.title}
                          onClick={handleOpenChat}
                          className="btn-yellow-light whitespace-nowrap"
                          arrow={false}
                        >
                          <Icon name="map-pin" className="mr-1 h-4 w-4" />
                          {link.title}
                        </Button>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatbotSuggestionsParagraph;
